import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchBuscaApuracaoDetalhada } from '../api/BuscaApuracaoDetalhadaApi';
import type { BuscaApuracaoDetalhadaResponse, FiltrosApuracaoDetalhada } from '../types';

export function useBuscaApuracaoDetalhada(
  filtros?: FiltrosApuracaoDetalhada,
  options?: Omit<UseQueryOptions<BuscaApuracaoDetalhadaResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const query = useQuery<BuscaApuracaoDetalhadaResponse, Error>({
    queryKey: ['apuracao-detalhada', cnpjGestor, filtros],
    queryFn: () => fetchBuscaApuracaoDetalhada(filtros),
    staleTime: 2 * 60 * 1000,
    ...options,
    enabled: (options?.enabled ?? true) && !!cnpjGestor,
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar apuração detalhada',
      description: 'Não foi possível carregar os dados. Tente novamente.',
    });
  }, [query.error, toast]);

  return query;
}
